import { useCallback, useEffect, useState } from 'react';

import { getPlayer } from '../playerService';

import type { Player } from '@schibsted-svp/web-player';

export const usePlayer = () => {
  const [player, setPlayer] = useState<Player>();

  const onPlayerReady = useCallback(async () => {
    try {
      const playerInstance = await getPlayer();
      if (playerInstance !== player) {
        setPlayer(playerInstance);
      }
    } catch (e) {
      console.error(e);
    }
  }, [player]);

  useEffect(() => {
    document.addEventListener('playerReady', onPlayerReady);

    return () => {
      document.removeEventListener('playerReady', onPlayerReady);
    };
  }, []);

  useEffect(() => {
    onPlayerReady();
  }, []);

  return player;
};
